import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AuthForm from '../components/auth/AuthForm';
import AuthTemplate from '../components/auth/AuthTemplate';
import { register } from '../api';

const RegisterPage = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // URL에서 id 파라미터 추출
    const queryParams = new URLSearchParams(location.search);
    const initialId = queryParams.get('id') || '';

    const [form, setForm] = useState({
        id: initialId,
        password: 'social-linked', // API 서버에서 무시하더라도 형식상 채워둠
        name: ''
    });

    useEffect(() => {
        if (initialId) {
            setForm(prev => ({ ...prev, id: initialId }));
        }
    }, [initialId]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        try {
            // API 호출 (서버는 세션/쿠키의 인증 정보를 우선하여 처리할 예정)
            await register({
                id: form.id,
                password: form.password,
                name: form.name
            });
            alert('서비스 연동이 완료되었습니다! 다시 로그인해주세요.');
            navigate('/login');
        } catch (error) {
            alert('회원가입 처리 중 오류가 발생했습니다.');
        }
    };

    return (
        <AuthTemplate>
            <AuthForm type="register" form={form} onChange={handleChange} onSubmit={handleSubmit} />
        </AuthTemplate>
    );
};
export default RegisterPage;

